import React, { Fragment, useContext, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";

/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import GemarBg from "../../../images/Gemar-USA-Logo-RGB-POS.png";
import GemarLogo from "../../../images/g-logo.png";


const NavHader = () => {

  const dispatch = useDispatch();
  let navigate = useNavigate();

  const currentUser = useSelector(x => x.auth.user);
  const [toggle, setToggle] = useState(false);
  const { navigationHader, openMenuToggle, background } = useContext(
    ThemeContext
  );
  const navigateTo = () => {

    if (currentUser.UserTypeID === 1 || currentUser.UserTypeID === 2 ||currentUser.UserTypeID === 8) {
      let path = "dashboard";
      navigate(path);

    }

  }


  return (
    <div className="nav-header">
      <a onClick={navigateTo} className="brand-logo">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <img src={GemarBg}
              className="attachment-large size-large vertical-align brand-title" alt="" loading="lazy"></img>

          </Fragment>
        ) : (
          <Fragment>
            <img src={GemarLogo}
              className="attachment-large size-large vertical-align logo-abbr" alt="" loading="lazy"></img>
            <img src={GemarBg}
              className="attachment-large size-large vertical-align brand-title" alt="" loading="lazy"></img>

          </Fragment>
        )}
      </a>


      <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          openMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div>
    </div>
  );
};

export default NavHader;
